import { TextField, InputAdornment, IconButton } from "@mui/material";
import { styled } from "@mui/material/styles";
import { FiEye, FiEyeOff } from "react-icons/fi";
import { useState } from "react";

const CssTextField = styled(TextField)({
  "& input": {
    color: "white",
    height: "2.4vh",
  },
  width: "75vw",
  maxWidth: "420px",
  marginTop: "22px",
  caretColor: "white",

  "& label.MuiFormLabel-colorPrimary": {
    color: "#b8b8b8",
  },
  "& label.Mui-focused": {
    color: "white",
  },
  "& label.MuiFormLabel-filled": {
    color: "#b8b8b8",
  },
  "& .MuiInput-underline:after": {
    borderBottomColor: "white",
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: "#b8b8b8",
    },
    "&:hover fieldset": {
      borderColor: "white",
    },

    "&.Mui-focused fieldset": {
      borderColor: "white",
    },
  },
});

export const Input = ({ value, type, ...props }) => {
  const isPassword = type === "password";
  const [showPassword, setShowPassword] = useState(false);

  return (
    <CssTextField
      {...props}
      value={value}
      type={showPassword ? "text" : type}
      InputProps={{
        ...(isPassword && {
          endAdornment: (
            <InputAdornment position='end'>
              <IconButton
                onClick={() => setShowPassword(!showPassword)}
                edge='end'
                tabIndex={-1}>
                {showPassword ? (
                  <FiEyeOff className='text-lg text-white/80' />
                ) : (
                  <FiEye className='text-lg text-white/80' />
                )}
              </IconButton>
            </InputAdornment>
          ),
        }),
      }}
    />
  );
};
